import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  CircularProgress,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PageLayout from '../../components/layout/PageLayout';
import Can from '../../components/permissions/Can';
import { useGetLeadQuizByIdQuery } from '../../store/api';
import { toast } from 'react-toastify';
import { buildLeadQuizRelationParams } from './leadQuizApiHelpers';

const row = (label, value) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary" display="block">
      {label}
    </Typography>
    <Typography variant="body1" sx={{ wordBreak: 'break-word' }}>
      {value ?? '—'}
    </Typography>
  </Grid>
);

const ViewLeadQuiz = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const {
    data,
    isLoading: loading,
    isError,
    error,
  } = useGetLeadQuizByIdQuery(
    { id, params: buildLeadQuizRelationParams() },
    { skip: !id }
  );

  const quiz = data?.data ?? data ?? null;

  useEffect(() => {
    if (isError) {
      toast.error(error?.data?.message || 'Failed to load lead quiz');
      navigate('/lead-quizzes');
    }
  }, [isError, error, navigate]);

  if (loading || !quiz) {
    return (
      <PageLayout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight={320}>
          <CircularProgress />
        </Box>
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/lead-quizzes')} sx={{ mb: 2 }}>
          Back to lead quizzes
        </Button>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, flexWrap: 'wrap', gap: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 600, color: 'primary.main' }}>
            Lead Quiz
          </Typography>
          <Can permission="lead-quiz-edit">
            <Button variant="outlined" size="small" onClick={() => navigate(`/lead-quizzes/edit/${id}`)}>
              Edit
            </Button>
          </Can>
        </Box>

        <Card>
          <CardContent sx={{ p: 3 }}>
            <Grid container spacing={2}>
              {row('Question', quiz.question)}
              {row('Status', quiz.status?.name ?? quiz.status?.label ?? quiz.status_name)}
              {row('Author', quiz.author?.name ?? quiz.author?.username)}
              {row('Created at', quiz.created_at)}
            </Grid>
          </CardContent>
        </Card>
      </Container>
    </PageLayout>
  );
};

export default ViewLeadQuiz;
